import { GetContract } from "@/services/fhir/contract/GetContract";
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useOrganizationContext } from "./OrganizationContext";
import { Contract } from "fhir/r5";

type ContractResource = Contract;

/** Identifier FHIR do Contract desta extensão: "teleconsultoria" */
interface TeleconsultoriaContractContextValue {
  contractTeleconsultoria: ContractResource | null;
  refetchContract: () => Promise<void>;
  loading: boolean;
}

interface TeleconsultoriaContractContextProviderProps {
  children: React.ReactNode;
}

export const TeleconsultoriaContractContext =
  createContext<TeleconsultoriaContractContextValue>(
    {} as TeleconsultoriaContractContextValue,
  );

export function TeleconsultoriaContractContextProvider({
  children,
}: TeleconsultoriaContractContextProviderProps) {
  const { organization } = useOrganizationContext();
  const [contractTeleconsultoria, setContractTeleconsultoria] =
    useState<ContractResource | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchContract = useCallback(async () => {
    setLoading(true);
    try {
      if (!organization?.id) {
        console.warn("Nenhuma organização selecionada");
        setContractTeleconsultoria(null);
        return;
      }

      const contractData = await GetContract({
        organization: organization.id,
        count: 1,
        sort: true,
        status: "executed",
        identifier: "teleconsultoria",
      });

      if (contractData?.entry?.[0]?.resource) {
        setContractTeleconsultoria(contractData.entry[0].resource);
      } else {
        setContractTeleconsultoria(null);
      }
    } catch (error) {
      console.error("Erro ao buscar contrato de Teleconsultoria:", error);
      setContractTeleconsultoria(null);
    } finally {
      setLoading(false);
    }
  }, [organization]);

  useEffect(() => {
    fetchContract();
  }, [fetchContract]);

  const contextValue: TeleconsultoriaContractContextValue = {
    loading,
    contractTeleconsultoria,
    refetchContract: fetchContract,
  };

  return (
    <TeleconsultoriaContractContext.Provider value={contextValue}>
      {children}
    </TeleconsultoriaContractContext.Provider>
  );
}

export function useTeleconsultoriaContractContext() {
  return useContext(TeleconsultoriaContractContext);
}
